import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.helpers.handleTemplatePayerErrors', {
    payerRequiredError: 'Payer needs to be set.',
});
